import { render, staticRenderFns } from "./indexManage.vue?vue&type=template&id=8bd7cce4&scoped=true&"
import script from "./indexManage.vue?vue&type=script&lang=js&"
export * from "./indexManage.vue?vue&type=script&lang=js&"
import style0 from "./indexManage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./indexManage.vue?vue&type=style&index=1&id=8bd7cce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd7cce4",
  null
  
)

export default component.exports